import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scrolls to top on route change, but NOT when only the language segment changes.
 * Rule: paths /pe and /en are considered equivalent for scroll purposes.
 */
const stripLang = (pathname) => {
  const parts = pathname.split("/").filter(Boolean);
  if (parts.length === 0) return "/";
  if (parts[0] === "pe" || parts[0] === "en") {
    return "/" + parts.slice(1).join("/");
  }
  return pathname;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevRef = useRef(stripLang(pathname));

  useEffect(() => {
    const stripped = stripLang(pathname);
    if (stripped !== prevRef.current) {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
      prevRef.current = stripped;
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
